// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1767":"RelatedContent","8143":"NewsListingPage","9815":"NewsPage"}[chunkId] + "_" + {"1767":"933d210e49a85985a224","8143":"52100062ac1c8c9b7883","9815":"933d210e49a85985a224"}[chunkId] + ".css";
};